var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.628,
    height: 27.628,
    viewBox: "0 0 27.628 27.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.c5b3d8f152339ecb75c5851ec0975733d{fill:currentColor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H27.628V27.628H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c5b3d8f152339ecb75c5851ec0975733d",
    d: "M4.151,19.814H22.57a1.151,1.151,0,1,0,0-2.3H4.151a1.151,1.151,0,1,0,0,2.3Zm0-5.756H22.57a1.151,1.151,0,1,0,0-2.3H4.151a1.151,1.151,0,1,0,0,2.3ZM3,7.151A1.155,1.155,0,0,0,4.151,8.3H22.57a1.151,1.151,0,1,0,0-2.3H4.151A1.155,1.155,0,0,0,3,7.151Z",
    transform: "translate(0.454 0.907)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.3bcd6630.svg";
export { ForwardRef as ReactComponent };